import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const user_augmontApi = createAsyncThunk("user_augmont", async () => {
  const response = await axiosInstance.get("/user_augmont");
  return response.data;
});

const user_augmontSlice = createSlice({
  name: "user_augmont",
  initialState: {
    user_augmont: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(user_augmontApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(user_augmontApi.fulfilled, (state, action) => {
        state.user_augmont = action.payload;
        state.loading = false;
      })
      .addCase(user_augmontApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default user_augmontSlice.reducer;
